// extracted by mini-css-extract-plugin
export default {"root":"NotEditablePrompt_root__EP9nL","promptText":"NotEditablePrompt_promptText__TMqn9","activeNotificationsButton":"NotEditablePrompt_activeNotificationsButton__jR6nB"};